import { Kunde, Zahlungsempfaenger } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';
import { Observable, Subject } from 'rxjs';

export const TYPE_ZAHLUNGSEMPFAENGER = 'ZAHLUNGSEMPFAENGER';

export interface ZahlungsempfaengerModelConfig extends DynamicFormValueControlModelConfig<Zahlungsempfaenger> {
  kunden?: Kunde[];
  removeRechnungssteller?: boolean;
  addDirektAnGeschPerson?: boolean;
}

export class ZahlungsempfaengerModel extends DynamicFormValueControlModel<Zahlungsempfaenger> {
  @serializable() readonly type: string = TYPE_ZAHLUNGSEMPFAENGER;
  @serializable() removeRechnungssteller: boolean;
  @serializable() addDirektAnGeschPerson: boolean;
  @serializable() kunden: Kunde[] | null;
  kundenChange$: Observable<Kunde[] | null>;

  constructor(config: ZahlungsempfaengerModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.removeRechnungssteller = config.removeRechnungssteller || false;
    this.addDirektAnGeschPerson = config.addDirektAnGeschPerson || false;

    let _kunden: Kunde[] | null = config.kunden || null;
    const kundenChangeSubject = new Subject<Kunde[] | null>();
    this.kundenChange$ = kundenChangeSubject.asObservable();

    Object.defineProperty(this, 'kunden', {
      set(kunden: Kunde[] | null) {
        _kunden = kunden;
        kundenChangeSubject.next(kunden);
      },
      get(): Kunde[] | null {
        return _kunden;
      }
    });
  }
}
